/* 
 * CREATION HORIZONTAL PAGES
 */

import { scrollThreshold, removeScrollThreshold } from "../shared/scrollThreshold";

let scrollListener;

export function bootstrap() {
  const button = document.querySelector('.js-gototop'),
        header = document.querySelector('.c-site-header'),
        target = document.querySelector('.c-glider');

  scrollListener = scrollThreshold(state => {
    if (state) {
      button.classList.remove('u-hidden');
      header.classList.add('u-hidden');
    } else {
      button.classList.add('u-hidden');
      header.classList.remove('u-hidden');
    }
  }, 200, target);

  button.addEventListener('click', e => {
    target.scrollTo(0, 0);
  });
}

export function destroy() {
  removeScrollThreshold(scrollListener);
}